import React from 'react'
const {useState, useCallback} = React
const emptyArr = []

function _ref(curr) {
  return !curr
}

const useSwitch = (defaultValue = false) => {
  if (defaultValue !== false && defaultValue !== true)
    throw new Error(
      'Default value `' +
        JSON.stringify(defaultValue) +
        '` did not match one of: ' +
        ('`' + JSON.stringify(false) + '`, `' + JSON.stringify(true) + '`')
    )

  const _ref_0 = useState(defaultValue) // @ts-ignore

  const setCurrent = _ref_0[1]
  const current = _ref_0[0]
  const toggle = useCallback(() => setCurrent(_ref), emptyArr)
  toggle.on = useCallback(() => setCurrent(true), emptyArr)
  toggle.off = useCallback(() => setCurrent(false), emptyArr)
  return [current, toggle]
}

export default useSwitch
